import React, {useState} from "react";
import "./IconSidebarV2.css";

const PARTNER_APPS = [
  { id: 1,  name: "eSmart Bazar",     short: "EB", link: "https://esmartbazar.online",                                   image: "https://esmartbazar.online/bm/uploads/media/2025/nlogo.png" },
  { id: 2,  name: "Budy Pay",         short: "BP", link: "https://play.google.com/store/apps/details?id=com.buddies.budypay", image: "https://futuredigiassets.com/fda/images/bpay.jpeg" },
  { id: 3,  name: "Real Estate",      short: "RB", link: "https://realestatebuddy.online/account/login.php",             image: "https://realestatebuddy.online/front/rl/rsblogo.png" },
  { id: 4,  name: "Citylog",          short: "CL", link: "https://realestatebuddy.online/account/login.php",             image: "https://citylog.in/assets/images/logo/businessdirectory.jpg" },
  { id: 5,  name: "BDY Matrimonial",  short: "BM", link: "https://bdymatrimonial.com/login",                             image: "https://bdymatrimonial.com/assets/uploads/logo/testlogobdy.png" },
  { id: 6,  name: "Life Transform",   short: "LT", link: "https://bizedtech.online/dashboard/",                          image: "https://lifetransform.in/wp-content/uploads/2022/09/Life-Transform-Logo.png" },
  { id: 7,  name: "New Life",         short: "NL", link: "https://newlifeshelter.org/login",                             image: "https://newlifeshelter.org/storage/uploads/Setting/4751760531332.png" },
  { id: 8,  name: "Biz Buddies",      short: "BB", link: "https://businessbuddies.online/bb/user/login/",                 image: "https://futuredigiassets.com/fda/images/bblogo.png" },
  { id: 9,  name: "BDY Chain",        short: "BC", link: "https://bdychain.com/cirkle-login/",                            image: "https://futuredigiassets.com/fda/images/bdychain.png" },
  { id: 10, name: "BUDES",            short: "BD", link: "https://www.budes.in/",                                        image: (typeof process !== "undefined" && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : "") + "/link10.png" },
];

function PartnerCard({ icon }) {
  const [hasError, setHasError] = useState(false);
  const fallback = icon.short || icon.name.slice(0, 2).toUpperCase();

  return (
    <button
      type="button"
      className="fm-strip__card"
      onClick={() => window.open(icon.link, "_blank", "noopener,noreferrer")}
      title={icon.name}
      aria-label={`Open ${icon.name}`}
    >
      <div className="fm-strip__img-wrap">
        {!hasError && icon.image ? (
          <img
            src={icon.image}
            alt=""
            className="fm-strip__img"
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={() => setHasError(true)}
          />
        ) : (
          <div className="fm-strip__fallback">{fallback}</div>
        )}
      </div>
      <span className="fm-strip__label">{icon.name}</span>
    </button>
  );
}

export function IconSidebarV2() {
  return (
    <div className="fm-strip" role="navigation" aria-label="Partner apps">
      <div className="fm-strip__track">
        <span className="fm-strip__eyebrow">Partners</span>
        {PARTNER_APPS.map((icon) => (
          <PartnerCard key={icon.id} icon={icon} />
        ))}
      </div>
    </div>
  );
}

export default IconSidebarV2;